import {FETCH_WORKSPACE_STATS_SUCCESS} from "../actions/stats";

const initialState = {
    workspaceStats: {fetched: false}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_WORKSPACE_STATS_SUCCESS:
            return Object.assign({}, state, {
                workspaceStats: {
                    ...action.payload,
                    fetched: true
                }
            });
        default:
            return state
    }
}


